import React, { useEffect } from 'react';
import './UIToast.scss';

interface UIToastProps {
  message: string;
  onClose: () => void;
  type?: 'success' | 'error' | 'info' | 'warning';
  duration?: number;
}

const UIToast: React.FC<UIToastProps> = ({ message, onClose, type = 'info', duration = 3000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => {
      clearTimeout(timer);
    };
  }, [onClose, duration]);

  const toastClass = `UIToast UIToast--${type}`;

  return (
    <div className={toastClass}>
      <div className="UIToast__message">{message}</div>
    </div>
  );
};

export default UIToast;
